export function createUser(response) {
    const { token, ...rest } = response;

    return {
        ...rest,
        tokens: [ token ]
    };
}